import { useState, useEffect, useMemo, useCallback } from "react";
import middleware from "../../../Api/Middleware";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router";
import "../../../Main/Main.css";
import "./EditBlueprintSetting.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faPen,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { Modal } from "react-bootstrap";
import PageTemplate from "../../../Templates/PageTemplate";
import TablePreset from "../../../Table/TablePreset";
import CheckboxHeader from "../../../Table/TableComponents/CheckboxHeader";
import SortableHeader from "../../../Table/TableComponents/SortableHeader";
import { useTable } from "react-table";
import CheckboxCell from "../../../Table/TableComponents/CheckboxCell";
import { BorderedTextInput } from "../../../HouseStyle/Components/Inputs";
import { ButtonBlue, ButtonLightGrey } from "../../../HouseStyle/Components/Buttons";
import ToastError from "../../../Toasts/ToastError";
import ToastSuccess from "../../../Toasts/ToastSuccess";

function EditBlueprintSetting() {
  const navigate = useNavigate();
  const cookies = new Cookies();
  const [show, setShow] = useState(false);
  const [selectedSizeIds, setSelectedSizeIds] = useState([]); // usestate for the selected checkboxes
  const [loading, setLoading] = useState(true); // useState for page loading
  const [searchengine, setSearchengine] = useState("");
  const [optionChosen, setOptionChosen] = useState("");
  const [editBlueprintName, setEditBlueprintName] = useState("");
  const [blueprintData, setBlueprintData] = useState([]);
  const [blueprintTitle, setBlueprintTitle] = useState("");
  const [oldSizes, setOldSizes] = useState([]); // useState for all products in the database
  const [sizes, setSizes] = useState([]); // useState for all products in the database
  const [sizeName, setSizeName] = useState("");
  const [showEditSizeModal, setShowEditSizeModal] = useState(false);
  const [pagination, setPagination] = useState({
    page_size: 10,
    page: 1,
    max_items: 0,
    begin_of_page: 0,
    end_of_page: 0,
  }); // the useState for the pagination for the table
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedIdsSizes, setSelectedIdsSizes] = useState([]);
  const [orderLeft, setOrderLeft] = useState({ orderBy: '', direction: '' }); // left table
  const [orderRight, setOrderRight] = useState({ orderBy: '', direction: '' }); // right table
  const [searchBar, setSearchBar] = useState("");
  const [searchBarSizes, setSearchBarSizes] = useState("");
  // handles to close the de-activate modal
  const handleCloseEditSize = () => setShowEditSizeModal(false);

  const [paginationSizes, setPaginationSizes] = useState({
    page_size: 10,
    page: 1,
    max_items: 0,
    begin_of_page: 0,
    end_of_page: 0,
  })
  const [sizesAll, setSizesAll] = useState([]);
  // fetched all the products and the stock an the colors from the database
  const fetchAll = async () => {
    try {
      const storedData = localStorage.getItem("Blueprintdata");
      if (!storedData) return console.log("Blueprint data not found");

      const blueprintData = JSON.parse(storedData);

      const searchQuery = searchBar.trim()
        ? `&searchTerm=${encodeURIComponent(searchBar.trim())}&noSearch=["primary_key","version","size_id","status","updated_at","created_at","updator_user_id","creator_user_id"]`
        : "";

      const orderQueryLeft = `&orderBy=${orderLeft.orderBy || 'sorting_order'}&orderDirection=${orderLeft.direction || 'asc'}`;

      const fetchSizes = await middleware.get(
        `sp/sizesTableAll?page=${pagination.page}&page_size=${pagination.page_size}${orderQueryLeft}${searchQuery}&filtering=size_id=${blueprintData.size_ids}|status=1`
      );

      setSizes(fetchSizes.data.data);
      setOldSizes(fetchSizes.data.data);
      setPagination({
        ...pagination,
        max_items: fetchSizes.data.total,
        begin_of_page: fetchSizes.data.from,
        end_of_page: fetchSizes.data.to,
      });

    } catch (error) {
      console.error(error);
    }
  };

  const fetchSizes = async () => {
    try {
      const storedData = localStorage.getItem("Blueprintdata");
      if (!storedData) return console.warn("Blueprint data not found");

      const blueprintData = JSON.parse(storedData);

      const searchQuery = searchBarSizes.trim()
        ? `&searchTerm=${encodeURIComponent(searchBarSizes.trim())}&noSearch=["primary_key","size_id","version","status","sorting_order","created_at", "updated_at","updator_user_id","creator_user_id"]`
        : "";

      const orderQueryRight = `&orderBy=${orderRight.orderBy || 'sorting_order'}&orderDirection=${orderRight.direction || 'asc'}`;

      const fetchSizesAll = await middleware.get(
        `sp/sizesTableAll?page=${paginationSizes.page}&page_size=${paginationSizes.page_size}${orderQueryRight}${searchQuery}&filtering=size_id!=${blueprintData.size_ids}|status=1`
      );

      setSizesAll(fetchSizesAll.data.data);
      setPaginationSizes({
        ...paginationSizes,
        max_items: fetchSizesAll.data.total,
        begin_of_page: fetchSizesAll.data.from,
        end_of_page: fetchSizesAll.data.to,
      });

    } catch (error) {
      console.error(error);
    }
  };

  // useEffect that fires every time the pagination.page_size or pagination.page changes and on every fire it uses the fetchall function
  useEffect(() => {
    fetchAll();
    setLoading(false);
  }, [pagination.page_size, pagination.page, orderLeft, searchBar]);

  useEffect(() => {
    fetchSizes();
    setLoading(false);
  }, [paginationSizes.page_size, paginationSizes.page, orderRight, searchBarSizes]);

  // const submitSizes = async (event) => {
  //   event.preventDefault();

  //   try {
  //     const sizeResponse = await middleware.post(`products/sizes`, {
  //       main: sizeNameNew,
  //       sorting_order: sizeNewSortingOrder,
  //     });

  //     const newData = await putSizesBlueprint(sizeResponse.data.size_id);
  //     if (!newData) {
  //       console.error("Error while updating");
  //       return;
  //     }

  //     localStorage.setItem("Blueprintdata", JSON.stringify(newData));
  //     setSizeNameNew("");
  //     setSizeNewSortingOrder("");
  //     setShowNewSizeModal(false);
  //     fetchAll();
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const putSizesBlueprint = async (newSizeId) => {
    try {
      const res = await middleware.put(`products/sizes/blueprints`, {
        blueprint_id: blueprintData.blueprint_id,
        size_ids:
          (blueprintData.size_ids ? blueprintData.size_ids + "," : "") +
          newSizeId,
      });
      return res.data;
    } catch (error) {
      console.error(error);
    }
  };

  // Simplified putNameBlueprint function - with duplicate name error handling
  const putNameBlueprint = async (title) => {
    if (title.trim() === "") {
      ToastError("Veld mag niet leeg zijn");
      return;
    }
    try {
      const res = await middleware.put(`products/sizes/blueprints`, {
        blueprint_id: blueprintData.blueprint_id,
        title: title,
      });
      // Save the blueprint data and update state
      localStorage.setItem("Blueprintdata", JSON.stringify(res.data.data));
      setBlueprintData(res.data.data);
      setBlueprintTitle(res.data.data.title);
      setEditBlueprintName(false);
      ToastSuccess("Blauwprint titel succesvol aangepast");
      
      fetchAll();
      fetchSizes();
    } catch (error) {
      console.error(error);
      if (error.response?.data?.error?.includes("Duplicate") || 
          error.response?.data?.message?.includes("already exists") ||
          error.response?.status === 409) {
        ToastError("Een blauwdruk met deze naam bestaat al. Kies een andere naam.");
      } else {
        ToastError("Er is een fout opgetreden bij het wijzigen van de blauwdruk naam.");
      }

    }
  };

  const handleSelection = (sizeId, isSelected) => {
    if (isSelected) {
      setSelectedIds(previous => [...previous, sizeId]);
    } else {
      setSelectedIds(previous => previous.filter(id => id !== sizeId));
    }
  };

  const handleSelectionSizes = (sizeId, isSelected) => {
    if (isSelected) {
      setSelectedIdsSizes(previous => [...previous, sizeId]);
    } else {
      setSelectedIdsSizes(previous => previous.filter(id => id !== sizeId));
    }
  };

  const deactivateBlueprintSize = async () => {
    try {
      const promises = selectedIds.map(id =>
        middleware.put(`products/sizes`, {
          primary_key: id,
          status: 0,
        }));
      await Promise.all(promises);
      setSelectedIds([]);
      // Optionally, you can refresh the data or perform other actions here
      fetchAll();
    } catch (error) {
      console.error("Error deactivating sizes:", error);
    }
  }


  const columns = useMemo(
    () => {
      let columnsArray = [
        {
          Header: (
            <CheckboxHeader currentItem={sizes} selectedIds={selectedIds} setSelectedIds={setSelectedIds} pk={'size_id'}>
            </CheckboxHeader>
          ),
          accessor: "select",
          Cell: ({ row }) => {
            return (
              <CheckboxCell
                row={row}
                selectedIds={selectedIds}
                handleSelection={handleSelection}
                pk={'size_id'}
              />
            );
          }
        },
        {
          Header: () => (
            <SortableHeader currentItem={orderLeft} setItem={setOrderLeft} field="main" pos={'left'}>
              Maatserie
            </SortableHeader>
          ),
          accessor: "main",
          Cell: ({ row }) => {
            return <div
              className="text-left FlatTextLink "
            >{row.original.main}</div>;
          }
        },
      ];
      return columnsArray;
    },
    [orderLeft.orderBy, orderLeft.direction, selectedIds, setSelectedIds, sizes]
  );

  const columnsSizes = useMemo(
    () => [
      {
        Header: (
          <CheckboxHeader currentItem={sizesAll} selectedIds={selectedIdsSizes} setSelectedIds={setSelectedIdsSizes} pk={'size_id'}>
          </CheckboxHeader>
        ),
        accessor: "select",
        Cell: ({ row }) => {
          return (
            <CheckboxCell
              row={row}
              selectedIds={selectedIdsSizes}
              handleSelection={handleSelectionSizes}
              pk={'size_id'}
            />
          );
        }
      },
      {
        Header: () => (
          <SortableHeader currentItem={orderRight} setItem={setOrderRight} field="main" pos={"start"}>
            Maat
          </SortableHeader>
        ),
        accessor: 'main',
        Cell: ({ row }) => {
          return <a className="FlatTextLink text-decoration-none text-nowrap" onClick={() => { }}>{row.original.main}</a>
        }
      },
    ],
    [orderRight.orderBy, orderRight.direction, selectedIdsSizes, setSelectedIdsSizes, sizesAll,]
  );

  //   Table instance
  const tableInstanceSizes = useTable({ columns: columnsSizes, data: sizesAll });
  const tableInstance = useTable({ columns, data: sizes });

  const handleSearchChange = useCallback((value) => {
    setSearchBar(value);
    setPagination(prev => ({ ...prev, page: 1 }));
  }, []);

  const handleSearchChangeSizes = useCallback((value) => {
    setSearchBarSizes(value);
    setPaginationSizes(prev => ({ ...prev, page: 1 }));
  }, []);

  function handleShow() {
    if (selectedIds.length > 0) {
      setShow(true);
    } else {
      ToastError("Geen maten geselecteerd, selecteer een maat om te deactiveren");
    }
  }

  const ChangeStatus = async (status) => {
    try {
      if (!blueprintData || !blueprintData.blueprint_id) {
        ToastError("Blueprint data niet beschikbaar. Vernieuw de pagina.");
        return;
      }

      // Convert status to integer (0 or 1)
      const statusValue = status ? 1 : 0;
      const res = await middleware.put(`products/sizes/blueprints`, {
        blueprint_id: blueprintData.blueprint_id,
        status: statusValue
      });

      // Handle response
      if (res.data && (res.data.status === "success" || res.data.blueprint_id)) {
        const updatedData = res.data.data || res.data;
        localStorage.setItem("Blueprintdata", JSON.stringify(updatedData));
        setBlueprintData(updatedData);

        ToastSuccess(`Blueprint ${status ? "gepubliceerd" : "gearchiveerd"}`);
      } else {
        ToastError("Er is iets misgegaan bij het wijzigen van de status");
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error === "Id not found") {
        ToastError("Blueprint ID niet gevonden. Vernieuw de pagina.");
      } else {
        ToastError("Er is een fout opgetreden bij het wijzigen van de status");
      }
    }
  };

  const Add = async () => {
    if (selectedIdsSizes.length == 0) {
      ToastError('Geen maten geselecteerd');
      return;
    }
    try {
      const existingIds = blueprintData.size_ids ? blueprintData.size_ids.split(",") : [];
      const newIds = selectedIdsSizes.filter(id => !existingIds.includes(id));
      const combinedIds = [...existingIds, ...newIds].join(",");

      const res = await middleware.put(`products/sizes/blueprints`, {
        blueprint_id: blueprintData.blueprint_id,
        size_ids: combinedIds,
      });
      // Update de blueprintData en sla op in localStorage
      localStorage.setItem("Blueprintdata", JSON.stringify(res.data.data));
      setBlueprintData(res.data.data);
      setSelectedIdsSizes([]);
      // Vernieuw de data voor de maatserie-tabel
      fetchAll();
      fetchSizes();
      ToastSuccess("Maat toegevoegd");
    } catch (error) {
      console.error("Error adding sizes:", error);
    }
  };

  const Delete = async () => {
    if (selectedIds.length == 0) {
      ToastError('Geen maten geselecteerd');
      return;
    }
    try {
      // Haal de bestaande size_ids op als een array (allemaal strings)
      const existingIds = blueprintData.size_ids ? blueprintData.size_ids.split(",") : [];
      const selectedIdsStr = selectedIds.map(String);
      const remainingIds = existingIds.filter(id => !selectedIdsStr.includes(id));
      const combinedIds = remainingIds.join(",");

      const res = await middleware.put(`products/sizes/blueprints`, {
        blueprint_id: blueprintData.blueprint_id,
        size_ids: combinedIds,
      });

      // Update de blueprintData en sla de nieuwe data op
      localStorage.setItem("Blueprintdata", JSON.stringify(res.data.data));
      setBlueprintData(res.data.data);
      setSelectedIds([]);
      fetchAll();
      fetchSizes();
      ToastSuccess("Geselecteerde maten verwijderd");
    } catch (error) {
      console.error("Error deleting sizes:", error);
    }
  };

  const BlueprintSortingFunction = async (updatedItems) => {
    try {
      const blueprintId = blueprintData.blueprint_id;

      if (!blueprintId) {
        console.error("No blueprint_id found in blueprintData");
        return;
      }

      // Convert the updatedItems to a comma-separated string of size_ids
      const newSizeIdsOrder = updatedItems.map(item => item.original.size_id).join(',');

      // Call backend to update both blueprint CSV and sorting_order
      await middleware.put(`products/sizes/blueprints/sort`, {
        blueprint_id: blueprintId,
        size_ids: newSizeIdsOrder, // now a string
      });

      ToastSuccess("Volgorde succesvol aangepast", "sorting_success");

      // Refresh tables after sorting
      fetchAll();
      fetchSizes();

    } catch (error) {
      console.error("Error updating blueprint sorting:", error);
      ToastError("Fout bij het aanpassen van de volgorde", "sorting_error");
    }
  };

  // Helper to get blueprint_id from URL params or localStorage (always use the latest data)
  function getBlueprintId() {
    // Try to get blueprint_id from URL query params
    const params = new URLSearchParams(window.location.search);
    const urlId = params.get("blueprint_id");
    if (urlId) return urlId;

    // Fallback: Try to get blueprint_id from localStorage (always use latest data structure)
    const storedData = localStorage.getItem("Blueprintdata");
    if (storedData) {
      try {
        // Try both .data and root for compatibility
        const parsed = JSON.parse(storedData);
        // If the backend response is wrapped in .data, unwrap it
        if (parsed.data && parsed.data.blueprint_id) return parsed.data.blueprint_id;
        if (parsed.blueprint_id) return parsed.blueprint_id;
      } catch (e) {}
    }
    return null;
  }

  useEffect(() => {
    // Always fetch fresh blueprint data from the backend on mount
    const fetchBlueprintData = async () => {
      try {
        const blueprintId = getBlueprintId();
        if (!blueprintId) {
          ToastError("Blueprint data niet gevonden. Ga terug naar blauwdrukken.");
          return;
        }
        // Fetch latest blueprint data from backend
        const res = await middleware.get(`products/sizes/blueprints?blueprint_id=${blueprintId}`);
        // Accept both .data and .data.data for compatibility
        let blueprint = res.data?.data || res.data;
        // If the backend response is wrapped in .data, unwrap it
        if (blueprint.data && blueprint.data.blueprint_id) blueprint = blueprint.data;
        if (blueprint && blueprint.blueprint_id) {
          setBlueprintData(blueprint);
          setBlueprintTitle(blueprint.title);
          localStorage.setItem("Blueprintdata", JSON.stringify(blueprint));
        } else {
          ToastError("Kon blauwdruk data niet ophalen.");
        }
      } catch (error) {
        ToastError("Fout bij ophalen blauwdruk data.");
      }
    };

    fetchBlueprintData();
  }, []);


  return (
    <>
      <Modal show={show} onHide={() => setShow(false)} centered size="xl">
        <Modal.Header className="modalTop d-flex justify-content-between">
          <Modal.Title className="ms-3 BlockTitle ">Let op!</Modal.Title>
          <button
            className="border-0 bg-transparent"
            variant="transparent"
            onClick={handleCloseEditSize}
          >
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </button>
        </Modal.Header>
        <Modal.Body className="modalCenter pb-0 justify-content-around">
          <div className="ms-3">
            U gaat {selectedIds.length}{" "}
            {selectedIds.length === 1 ? "item" : "items"} de-activeren. Weet U
            dat zeker?
          </div>
        </Modal.Body>
        <Modal.Footer className="modalBottom">
          <div className="d-flex flex-row">
            <div className="me-3">
              <ButtonLightGrey text={"Annuleren"} className="ms-3 btn bg-danger text-white" onClickFunction={() => setShow(false)} />
            </div>
            <ButtonBlue
              text={"De-activeren"}
              onClickFunction={() => {
                setShow(false);
                deactivateBlueprintSize();
              }}
            />
          </div>
        </Modal.Footer>
      </Modal>

      {/* <Modal
        id="modalBlueprint"
        show={showNewSizeModal}
        onHide={handleCloseNewSize}
        centered
        size="xl"
      >
        <Modal.Header className="modalTop d-flex justify-content-between">
          <Modal.Title className="ms-3 BlockTitle">Nieuwe maat</Modal.Title>
          <button
            className="border-0 bg-transparent"
            variant="transparent"
            onClick={handleCloseNewSize}
          >
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </button>
        </Modal.Header>
        <form>
          <Modal.Body className="modalCenter pb-0 justify-content-around">
            <div className="w-100">
              <div className="mb-3">
                <label className="FlatText">Maat naam*</label>
                <BorderedTextInput
                  placeholder="Maat naam"
                  required={true}
                  inputValue={sizeNameNew}
                  setInputValue={setSizeNameNew}
                ></BorderedTextInput>
              </div>
              <div>
                <label className="FlatText">Sorteer volgorde*</label>
                <BorderedTextInput 
                  placeholder="Sorteer volgorde"
                  required={true}
                  setInputValue={setSizeNewSortingOrder}
                  inputValue={sizeNewSortingOrder}
                ></BorderedTextInput>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="modalBottom">
            <ButtonBlue text={"Opslaan"} onClickFunction={(e) => submitSizes(e)}/>
          </Modal.Footer>
        </form>
      </Modal> */}

      <PageTemplate navbarTitle={"Blauwdruk bewerken"} pageIsLoading={loading}>
        <div className="w-100">
          <div className="d-flex justify-content-between flex-column mb-4  editBlueprintOverview">
            <div className="d-flex flex-row justify-content-start align-items-center mb-4">
              <button
                className="btn bg-white fw-semibold rounded-pill"
                onClick={() => navigate("/algemene/instellingen/product/blauwdrukken")}
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
              {editBlueprintName == false ? (
                <div className="d-flex flex-row align-items-center">
                  <h3 className="mb-0 ms-3 d-flex">
                    {blueprintData.title || blueprintTitle}
                  </h3>
                  <div className="editIconBlueprintName">
                    <FontAwesomeIcon
                      className=" ms-2 d-flex flex-row hover"
                      onClick={() => setEditBlueprintName(true)}
                      style={{ width: "15px", height: "15px" }}
                      icon={faPen}
                    />
                  </div>
                </div>
              ) : (
                <div className=" d-flex ms-3">
                  <BorderedTextInput
                    placeholder="Blueprint titel"
                    name="colorName"
                    inputValue={blueprintTitle ?? ''}
                    setInputValue={setBlueprintTitle}
                    style={{ height: "38px" }}
                  />
                  <div style={{ width: "16px" }} /> {/* Space between input and button */}
                  <ButtonBlue
                    text={'Opslaan'}
                    onClickFunction={() => {
                      // Only submit if the title has changed
                      if ((blueprintTitle ?? "") !== (blueprintData.title ?? "")) {
                        putNameBlueprint(blueprintTitle);
                      } else {
                        setEditBlueprintName(false);
                      }
                    }}
                  />
                </div>
              )}
              <div className="d-flex flex-column align-items-center ms-3">
                {blueprintData.status ? <p className="mb-1 p-0">Gepubliceerd</p> : <p className="mb-1 p-0">Gearchiveerd</p>}
                <label className="switchActiveProduct">
                  <input type="checkbox" checked={blueprintData.status ?? false}
                    onChange={(e) => ChangeStatus(e.target.checked)} />
                  <span className="sliderActiveProduct round">
                  </span>
                </label>
              </div>
            </div>
            <div className=" d-flex justify-content-between w-100 flex-wrap">
              <div className="editBlueprint">
                <TablePreset
                  enableDrag={true}
                  apiEndPoint={"products/sizes"}
                  data={[{ 'selectedIds': selectedIds, 'tableInstance': tableInstance, 'pagination': pagination, 'primary_key': 'size_id' }]}
                  tableLoading={loading}
                  actionOptions={[{ title: "Verwijderen", function: () => Delete() }]}
                  searchBar={[{ shown: true, searchFunction: handleSearchChange }]}
                  handleSelection={handleSelection}
                  setPagination={setPagination}
                  leftButtons={[]}
                  sortingKey="size_id"
                  sortingFunction={BlueprintSortingFunction}
                />
              </div>
              <div className="editBlueprint">
                <TablePreset
                  enableDrag={true}
                  apiEndPoint={"products/sizes"}
                  data={[{ 'selectedIds': selectedIdsSizes, 'tableInstance': tableInstanceSizes, 'pagination': paginationSizes, 'primary_key': 'size_id' }]}
                  tableLoading={loading}
                  actionOptions={[{ title: "Toevoegen", function: () => Add() }]}
                  searchBar={[{ shown: true, searchFunction: handleSearchChangeSizes, }]}
                  handleSelection={handleSelectionSizes}
                  setPagination={setPaginationSizes}
                  leftButtons={[]}
                />
              </div>
            </div>
          </div>
        </div>
      </PageTemplate>
    </>
  );
}

export default EditBlueprintSetting;